import ReportsContainer from "../../container/admin/reports";

const ReportsView = () => {
    return <ReportsContainer />;
};

export default ReportsView;
